import { render, staticRenderFns } from "./add_article.vue?vue&type=template&id=1e44d257&scoped=true&"
import script from "./add_article.vue?vue&type=script&lang=js&"
export * from "./add_article.vue?vue&type=script&lang=js&"
import style0 from "./add_article.vue?vue&type=style&index=0&id=1e44d257&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e44d257",
  null
  
)

export default component.exports